const styles = {
    profileLable: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#8697AB',
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
    },
    profileValue: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '21px',
        color: '#001533',
        marginBottom: '72px',
        overflowWrap: 'break-word',
        whiteSpace: 'break-spaces',
    },
    profileButton: {
        background: '#3876AA',
        borderRadius: '16px',
        width: '598px',
        height: '48px',
        margin: '0px 24px',
    },
};
export default styles;
